import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "is-size-4 mdi mdi-close" }, null, -1 /* HOISTED */)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_5 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.show,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "modal",
        style: _normalizeStyle({ width: _ctx.width, height: _ctx.height })
      }, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close(false))),
          class: "modal-close"
        }, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "body")
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ], 4 /* STYLE */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["show"]))
}